import { jsx } from 'panel';
import { LineChartEl } from 'common/charts/visualization/line-chart';
import { NoDataHero } from 'common/widgets/warning-hero/presets';
import { WarningHeroReportName } from 'common/widgets/warning-hero/constants';
import { SegmentLegendHeaderEl } from 'common/charts/misc/segment-legend-header';
export function template() {
  if (!this.helpers.hasResults()) {
    return jsx("div", {
      sel: '.retention-curve-chart'
    }, jsx(NoDataHero, {
      reportName: WarningHeroReportName.Retention
    }));
  }

  return jsx("div", {
    sel: '.root'
  }, jsx(SegmentLegendHeaderEl, {
    sel: '.segment-header'
  }), jsx(LineChartEl, {
    sel: '.line-chart',
    attrs: this.helpers.getLineChartAttrs(),
    props: this.helpers.getLineChartProps(),
    key: this.helpers.getChartType(),
    hook: {
      insert: _ref => {
        let {
          elm
        } = _ref;
        this.chartResizeObserver.observe(elm);
      },
      remove: (_ref2, removeCallback) => {
        let {
          elm
        } = _ref2;
        this.chartResizeObserver.unobserve(elm);
        removeCallback();
      }
    }
  }));
}